const dealClient = {
  id: null,
  dealId: null,
  clientType: null,
  existingClientId: null,
  name: null,
  createdBy: null,
  invoiceFrequencyId: null,
  invoiceFrequencyName: null,
  thirdPartyPortalId: null,
  vmsFee: null,
  contractorExpenses: null,
  directPlacementsExpenses: null
}

export default () => Object.assign({}, dealClient)
